/* Only the primary product image competes for the first viewport. */
(() => {
  const root = document.querySelector('#christ-book');
  if (!root) return;
  const load = img => {
    if (!img?.dataset.src) return;
    img.loading = 'eager';
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    delete img.dataset.src; delete img.dataset.srcset;
  };
  const pending = [...root.querySelectorAll('img[data-src]')];
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
    }), {rootMargin:'300px 0px',threshold:0.01});
    pending.forEach(img => observer.observe(img));
  } else pending.forEach(load);
  // Start the chosen slide before navigation; touch swipes are caught by observation.
  root.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    const inside = !!button.closest('[data-book-inside]');
    const track = root.querySelector(inside ? '.cb-inside-track' : '.cb-track');
    let index = Number(button.dataset.slide ?? button.dataset.insideSlide);
    if (button.matches('.cb-next,.cb-inside-next')) index = Math.round(track.scrollLeft/track.clientWidth)+1;
    if (button.matches('.cb-prev,.cb-inside-prev')) index = Math.round(track.scrollLeft/track.clientWidth)-1;
    if (Number.isFinite(index)) track.children[index]?.querySelectorAll('img').forEach(load);
  }, true);
  root.querySelectorAll('.cb-track,.cb-inside-track').forEach(track => track.addEventListener('keydown',event=>{
    if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) track.querySelectorAll('img[data-src]').forEach(load);
  },true));
})();

(() => {
  const root = document.querySelector('#christ-book');
  if (!root) return;
  const track = root.querySelector('.cb-track');
  const slides = [...track.children];
  const controls = [...root.querySelectorAll('.cb-thumb, .cb-dot')];
  const previous = root.querySelector('.cb-prev');
  const next = root.querySelector('.cb-next');
  let index = 0;
  const fit = () => {
    if (matchMedia('(max-width:749px)').matches) track.style.removeProperty('--cb-gallery-height');
    else track.style.setProperty('--cb-gallery-height', `${track.clientWidth * 4 / 3}px`);
  };
  const update = () => {
    index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    controls.forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.slide) === index)));
    previous.disabled = index === 0;
    next.disabled = index === slides.length - 1;
    fit();
  };
  const go = position => track.scrollTo({
    left: track.clientWidth * Math.max(0, Math.min(slides.length - 1, position)),
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
  controls.forEach(button => button.addEventListener('click', () => go(Number(button.dataset.slide))));
  previous.addEventListener('click', () => go(index - 1));
  next.addEventListener('click', () => go(index + 1));
  track.addEventListener('scroll', update, { passive: true });
  track.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    go(index + (event.key === 'ArrowRight' ? 1 : -1));
  });
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(track);
  update();
})();


/* Independent interior carousel; no autoplay and no shared hero-gallery state. */
(() => {
  const section = document.querySelector('[data-book-inside]');
  if (!section) return;
  const track = section.querySelector('.cb-inside-track');
  const slides = [...track.children];
  const dots = [...section.querySelectorAll('[data-inside-slide]')];
  const previous = section.querySelector('.cb-inside-prev');
  const next = section.querySelector('.cb-inside-next');
  const count = section.querySelector('.cb-inside-count');
  let index = 0;
  let frame = 0;
  const update = () => {
    frame = 0;
    const current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    index = current;
    dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === index)));
    previous.disabled = index === 0;
    next.disabled = index === slides.length - 1;
    const label = `${index + 1} / ${slides.length}`;
    if (count.textContent !== label) count.textContent = label;
  };
  const go = (position, instant = false) => {
    index = Math.max(0, Math.min(slides.length - 1, position));
    track.scrollTo({left: track.clientWidth * index, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  };
  previous.addEventListener('click', () => go(index - 1));
  next.addEventListener('click', () => go(index + 1));
  dots.forEach(dot => dot.addEventListener('click', () => go(Number(dot.dataset.insideSlide))));
  track.addEventListener('scroll', () => { if (!frame) frame = requestAnimationFrame(update); }, {passive: true});
  track.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    go(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1));
  });
  if ('ResizeObserver' in window) new ResizeObserver(() => go(index, true)).observe(track);
  update();
})();

